import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/app/client/layouts/auth.vue").then(m => m.default || m)),
  contacts: defineAsyncComponent(() => import("/app/client/layouts/contacts.vue").then(m => m.default || m)),
  custom: defineAsyncComponent(() => import("/app/client/layouts/custom.vue").then(m => m.default || m)),
  "customer-profile": defineAsyncComponent(() => import("/app/client/layouts/customer-profile.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/client/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/app/client/layouts/error.vue").then(m => m.default || m)),
  "full-screen": defineAsyncComponent(() => import("/app/client/layouts/full-screen.vue").then(m => m.default || m))
}